import StreamService from "@/services/StreamService";

const defaultState = () => ({
  regions: {},
  isLoading: {},
  isLoaded: {},
});

const state = defaultState();

const mutations = {
  SET_LOADING(state, { category, isLoading }) {
    state.isLoading = { ...state.isLoading, [category]: isLoading };
  },
  SET_REGIONS(state, { category, regions }) {
    state.regions = { ...state.regions, [category]: regions };
    state.isLoaded = { ...state.isLoaded, [category]: true };
    state.isLoading = { ...state.isLoading, [category]: false };
  },
};

const regionsForPlatform = (list, category) =>
  (list || []).filter((r) => Array.isArray(r.platforms) && r.platforms.includes(category));

const actions = {
  async getRegions({ commit, dispatch, state }, category = 'list') {
    if (state.isLoaded[category]) {
      return state.regions[category];
    }

    if (category !== 'list') {
      if (!state.isLoaded.list) {
        await dispatch('getRegions', 'list');
      }
      const derived = regionsForPlatform(state.regions.list, category);
      if (derived.length) {
        commit("SET_REGIONS", { category, regions: derived });
        return derived;
      }
    }

    if (state.isLoading[category]) {
      return new Promise((resolve) => {
        const checkLoading = setInterval(() => {
          if (!state.isLoading[category]) {
            clearInterval(checkLoading);
            resolve(state.regions[category]);
          }
        }, 50);
      });
    }

    commit("SET_LOADING", { category, isLoading: true });
    try {
      const regions = await StreamService.getAvailableRegions(category);
      commit("SET_REGIONS", { category, regions });
      return regions;
    } catch (error) {
      commit("SET_LOADING", { category, isLoading: false });
      throw error;
    }
  },
};

const getters = {
  getRegionsByCategory: (state) => (category = 'list') => {
    return state.regions[category] || [];
  },
  isLoaded: (state) => (category = 'list') => {
    return state.isLoaded[category] || false;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
